<template>
<div>
    <NavBar/>
    <b-container>
        <b-row>
            <b-col cols="12" v-if="mainsaleOpen && walletAddress.length > 1">
                <br><br><br><br>
                 <h2 class="Header">FREE FESTIVE MINT</h2>
                 <br>
                 <img v-if="isMobile()" class="img" src="../assets/promo.gif" alt="">
                 <img v-if="!isMobile()" class="imgPC" src="../assets/promo.gif" alt="">
                 <br><br>
                 <h4 class="Header2">{{totalSupply}} / 1000 Minted!</h4>
                 <br><br>
                 <div v-if="!loadingTransaction">
                     <input type="number" min="1" max="20" v-model="mintTotal">
                     <button @click="mintFree()" class="buttonMint">Free Mint!</button>
                 </div>
                 <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                 <br><br><br><br>
            </b-col>


            <b-col cols="12" v-if="walletAddress.length < 30">
                <br><br><br><br>
                <h2 class="Header">Please connect to metamask! <br></h2><br>
                <button @click="mintFree()" class="buttonMint">Connect Wallet</button>
                <br><br><br><br>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import Web3 from 'web3';
import NavBar from './Navigation/NavBar.vue'
import contract from '../assets/contract.json'

export default {
    name: "Mint",
    components:{NavBar},
    data: function () {
            return {
                walletAddress: '',
                walletBalance: '',

                totalSupply: '',
                mintTotal: 1,

                loadingTransaction: false,

                b11christmasContract: '',
                contractAbi: contract.abi,
                contractAddress: contract.contractAddress,

                mainsaleOpen: false,

            }
    },
    mounted()
    {
      this.LoadEthWallet();

    },
    methods:{
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        mintFree()
        {
            this.loadingTransaction = true;
            if(this.mainsaleOpen)
            {
                this.b11christmasContract.methods.mint(this.mintTotal).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
            }
        },
        LoadEthWallet: function(){
            if (typeof window.ethereum !== 'undefined') 
            {
                web3 = new Web3(window.web3.currentProvider);
                web3.eth.net.getId()
                .then(network=>{
                    if(network == "137")
                    {
                        web3.eth.requestAccounts()
                        .then(acc=>{
                            this.walletAddress = acc[0];
                            web3.eth.getBalance(this.walletAddress)
                            .then(balance=>{
                                this.walletBalance = web3.utils.fromWei(balance, "ether");  
                                this.LoadContract();
                                
                            });
                        })
                        .catch(err=>{
                            console.log(err);
                        })                                   
                    }
                    else{
                        this.chainChange();
                    }          
                })
            }
        },
        LoadContract: function()
        {
            this.b11christmasContract = new web3.eth.Contract(this.contractAbi, this.contractAddress);
            
            this.b11christmasContract.methods.supply().call({from: this.walletAddress})
            .then(res=>{
                this.totalSupply = res;
                console.log(res)
                if(Number(res) >= 1000)
                {
                    this.mainsaleOpen = false;
                }
                else
                {
                    this.mainsaleOpen = true;
                }
            })
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x89' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },
    }
}
</script>

<style scoped>
.img
{
    width: 100%;
}
.Header
{
    color: white;
    text-transform: uppercase;
    font-weight: bold;
    font-style: italic;
}
.Header2
{
    color: white;
    text-transform: uppercase;
    font-weight: bold;
    font-style: italic;
}
.buttonMint
{
    background-color: black;
    border: white 2px solid !important;
    border-radius: 8px;
    color: white;
    border: 0;
    font-weight: 700;
    font-size: 20px;
    padding: 0.5%;
    margin: auto auto;
    transition: .3s;
}
</style>


// WEBPACK FOOTER //
// src/components/Mint.vue